{
  "links": {
    "title": "Gradex 链接",
    "opening": "正在打开此链接…",
    "unavailable": "无法连接 Gradex。请检查网络后重试。",
    "inactive": {
      "title": "此链接已失效",
      "body": "它可能已过期或被关闭。如果您认为它应当有效，请向发送者索取新的链接。"
    },
    "verify": {
      "title": "确认是您本人",
      "intro": "此链接发送至 {{email}}。我们会向该邮箱发送验证码，以确认是您本人。",
      "send": "发送验证码到我的邮箱",
      "enterTitle": "输入验证码",
      "sent": "我们已向 {{email}} 发送 6 位验证码，10 分钟内有效。",
      "label": "验证码",
      "checking": "正在核对…",
      "resend": "重新发送验证码",
      "resendIn": "{{time}} 后可重新发送",
      "errors": {
        "incorrect_code": "验证码不正确。请查看邮件后重试。",
        "expired_code": "验证码已过期。请重新获取。",
        "locked": "错误次数过多。请重新获取验证码。",
        "no_code": "请先获取验证码。",
        "rate_limited": "尝试次数过多。请稍后再试。",
        "generic": "出了点问题。请重试。"
      }
    },
    "done": {
      "title": "已完成",
      "body": "您可以关闭此页面。",
      "action": "完成"
    },
    "report": {
      "action": "举报此链接",
      "title": "举报此链接",
      "reasonLabel": "出了什么问题？",
      "reasons": {
        "NOT_FOR_ME": "这不是发给我的",
        "SUSPICIOUS": "看起来可疑",
        "UNWANTED": "我不想收到这类消息",
        "OTHER": "其他原因"
      },
      "noteLabel": "还有什么需要告诉我们的吗？（选填）",
      "send": "提交举报",
      "cancel": "取消",
      "thanks": "谢谢。Gradex 团队会进行核查。",
      "failed": "举报未能提交。请重试。"
    },
    "test": {
      "title": "测试链接",
      "body": "此测试链接有效：{{subject}} 的 {{level}} 视图。"
    }
  }
}
